@if (isOpen()) {
  <div 
    class="fixed inset-0 bg-black/50 flex items-center justify-center p-4 animate-fade-in max-h-[calc(100vh)]!"
    [style.z-index]="zIndex"
    (click)="onBackdropClick($event)"
  >
    <div 
      class="bg-white rounded-lg shadow-xl max-w-lg w-full animate-slide-up"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="'modal-title'"
    >
      <!-- Header -->
      <div class="flex items-start justify-between p-6 py-4 border-b {{ colorClasses.border }}">
        <div class="flex items-center gap-3">
          <span class="material-symbols-outlined text-3xl {{ colorClasses.text }}">
            {{ iconName }}
          </span>
          <h3 
            id="modal-title" 
            class="text-xl font-semibold font-heading text-heading-primary"
          >
            {{ title || (type === 'error' ? 'Error' : type === 'success' ? 'Éxito' : 'Advertencia') }}
          </h3>
        </div>
        <button
          type="button"
          class="text-gray-400 hover:text-gray-600 transition-colors"
          (click)="onClose()"
          aria-label="Cerrar"
        >
          <span class="material-symbols-outlined text-2xl">close</span>
        </button>
      </div>

      <!-- Body -->
      <div class="p-6 py-8">
        @if (messages.length === 1) {
          <p class="text-text-body">{{ messages[0] }}</p>
        } @else {
          <ul class="list-disc list-inside space-y-2 text-text-body">
            @for (msg of messages; track $index) {
              <li>{{ msg }}</li>
            }
          </ul>
        }
      </div>

      <!-- Footer -->
      <div class="flex justify-center gap-3 p-6 py-3 border-t border-border-2">
        <div class="close-btn">
          <button
            type="button"
            class="rounded-full font-semibold transition-all w-full"
            [ngClass]="{
                      'bg-red-500 hover:bg-red-600 text-white!': type === 'error',
                      'bg-secondary hover:bg-secondary text-white': type === 'success',
                      'bg-yellow-500 hover:yellow-600 text-white': type === 'warning'
                    }"
            (click)="type === 'warning' ? onSend() : onClose()"
          >
            <span class="btn-text">
              <span>{{ type === 'warning' ?( buttonLabel || 'Enviar') : 'Cerrar' }}</span>
            </span>
          </button>
        </div>        
      </div>
    </div>
  </div>
}
